var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecommendations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GENERAL-sera",
    transform: "translate(-6.25 -6.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16438",
    "data-name": "Tracciato 16438",
    d: "M67.206,75.288a13.655,13.655,0,1,1,0-27.311,13.917,13.917,0,0,1,5.908,1.338,16.832,16.832,0,1,0,0,24.635A13.917,13.917,0,0,1,67.206,75.288Z",
    transform: "translate(-17.383 -17.383)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_440",
    "data-name": "Ellisse 440",
    cx: 8.528,
    cy: 8.528,
    r: 8.528,
    transform: "translate(41.24 35.722)",
    fill: "none",
    stroke: "#e30613",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_939",
    "data-name": "Linea 939",
    y2: 8.416,
    transform: "translate(20.896 25.578)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16439",
    "data-name": "Tracciato 16439",
    d: "M26.4,41.5V51.811a1.879,1.879,0,0,0,1.9,1.9V77.06a1.867,1.867,0,0,0,1.951,1.784,1.918,1.918,0,0,0,1.784-1.784V53.65a1.879,1.879,0,0,0,1.9-1.9h0V41.5",
    transform: "translate(-9.238 -15.922)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16440",
    "data-name": "Tracciato 16440",
    d: "M118.521,77a1.867,1.867,0,0,1-1.951,1.784A1.918,1.918,0,0,1,114.787,77V65.684A2.76,2.76,0,0,0,112,62.9V54.425a19.686,19.686,0,0,1,4.124-12.541,1.4,1.4,0,0,1,1.951,0,1.343,1.343,0,0,1,.39,1V77Z",
    transform: "translate(-47.128 -15.916)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_441",
    "data-name": "Ellisse 441",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(7.25 7.25)",
    fill: "none",
    stroke: "#32285b",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_442",
    "data-name": "Ellisse 442",
    cx: 1.338,
    cy: 1.338,
    r: 1.338,
    transform: "translate(49.656 18.388)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_443",
    "data-name": "Ellisse 443",
    cx: 1.393,
    cy: 1.393,
    r: 1.393,
    transform: "translate(31.486 13.762)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1301",
    "data-name": "Rettangolo 1301",
    transform: "translate(38.62 24.302) rotate(-45)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1302",
    "data-name": "Rettangolo 1302",
    transform: "translate(61.422 18.363) rotate(-45)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1303",
    "data-name": "Rettangolo 1303",
    transform: "translate(30.08 21.665) rotate(-45)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1304",
    "data-name": "Rettangolo 1304",
    transform: "translate(65.43 21.066) rotate(-45)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7347",
    "data-name": "Raggruppa 7347",
    transform: "translate(50.994 11.867)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_940",
    "data-name": "Linea 940",
    y2: 0.613,
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_941",
    "data-name": "Linea 941",
    y2: 0.613,
    transform: "translate(0 2.118)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7348",
    "data-name": "Raggruppa 7348",
    transform: "translate(49.656 13.26)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_942",
    "data-name": "Linea 942",
    x2: 0.613,
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_943",
    "data-name": "Linea 943",
    x2: 0.613,
    transform: "translate(2.118)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7349",
    "data-name": "Raggruppa 7349",
    transform: "translate(57.069 19.001)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_944",
    "data-name": "Linea 944",
    y2: 0.557,
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_945",
    "data-name": "Linea 945",
    y2: 0.557,
    transform: "translate(0 2.118)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7350",
    "data-name": "Raggruppa 7350",
    transform: "translate(55.731 20.339)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_946",
    "data-name": "Linea 946",
    x2: 0.613,
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_947",
    "data-name": "Linea 947",
    x2: 0.613,
    transform: "translate(2.118)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7351",
    "data-name": "Raggruppa 7351",
    transform: "translate(45.308 15.211)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_948",
    "data-name": "Linea 948",
    y2: 0.557,
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_949",
    "data-name": "Linea 949",
    y2: 0.557,
    transform: "translate(0 2.118)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7352",
    "data-name": "Raggruppa 7352",
    transform: "translate(43.971 16.549)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_950",
    "data-name": "Linea 950",
    x2: 0.557,
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_951",
    "data-name": "Linea 951",
    x2: 0.557,
    transform: "translate(2.118)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7353",
    "data-name": "Raggruppa 7353",
    transform: "translate(26.47 16.27)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_952",
    "data-name": "Linea 952",
    y2: 0.557,
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_953",
    "data-name": "Linea 953",
    y2: 0.557,
    transform: "translate(0 2.118)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7354",
    "data-name": "Raggruppa 7354",
    transform: "translate(25.076 17.608)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_954",
    "data-name": "Linea 954",
    x2: 0.613,
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_955",
    "data-name": "Linea 955",
    x2: 0.613,
    transform: "translate(2.118)",
    fill: "none",
    stroke: "#32285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendations);
export default __webpack_public_path__ + "static/media/recommendations.7a3037062467db329c61fe09976581fa.svg";
export { ForwardRef as ReactComponent };